import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { UrlBuilder } from '../../models/frontend_entities/UrlBuilder';
import Constants from '../../Constants';
import {
  ChecklistTemplateVersionEntryFilterResultsModel,
  ChecklistTemplateVersionEntryInputUpdate
} from '../../models/checklist-template/checklist-template-version-entry-filter-results.model';
import { HttpClient } from '@angular/common/http';
import { CompoApp } from '../CompoApp';

@Injectable({ providedIn: 'root' })
export class ChecklistTemplateVersionEntryInputRequestService {

  //region INJECTIONS
  private http = inject(HttpClient);
  //endregion

  public updateInputs(
    entryId: string,
    updateDtos: ChecklistTemplateVersionEntryInputUpdate[]
  ): Observable<ChecklistTemplateVersionEntryFilterResultsModel> {
    const url: string =
      new UrlBuilder(Constants.URLS.checklistTemplateVersionEntryInput.baseUrl
        .replace('{checklistTemplateVersionEntryId}', entryId.toString()))
        .param('accessMode', inject(CompoApp).data.getAccessMode())
        .build();

    return this.http.put<ChecklistTemplateVersionEntryFilterResultsModel>(url, updateDtos);
  }
}
